import { render, staticRenderFns } from "./UserProjectAssignment.vue?vue&type=template&id=4669a7ca"
import script from "./UserProjectAssignment.vue?vue&type=script&lang=js"
export * from "./UserProjectAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports